import { Box, Title } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { LedgerAccountResourceFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  LedgerAccountSelector,
  formatAccountName,
} from 'modules/banking/components/LedgerAccountSelector'
import { InvoiceForm } from 'modules/finance/components/Invoices/Detail/Content/Form/types'
import type { LegalEntity } from 'modules/finance/components/Invoices/Detail/Content/Form/types'

interface LedgerAccountSectionProps {
  form: FormikProps<InvoiceForm>
  legalEntities: LegalEntity[]
  readonly: boolean
  canManageJournalEntries: boolean
  accountResource?: LedgerAccountResourceFragment | null
}

export const LedgerAccountSection: React.FC<LedgerAccountSectionProps> = ({
  form,
  legalEntities,
  readonly,
  canManageJournalEntries,
  accountResource,
}) => {
  if (!canManageJournalEntries || legalEntities.length === 0) {
    return null
  }

  const selectedLegalEntity = form.values.legalEntity
  const selectedLedgerAccount =
    selectedLegalEntity?.financeAccounts?.find((fa) => fa.id === form.values.ledgerAccountId) ||
    accountResource?.account

  return (
    <Box gap="s8" paddingTop="s8">
      <Title variant="400" title={i18n.t('finance.invoices.detail.fields.accounting')} />

      <LedgerAccountSelector
        legalEntityId={selectedLegalEntity?.id || '-1'}
        label={i18n.t('finance.invoices.detail.fields.ledger_account')}
        currentLedgerAccountName={formatAccountName(selectedLedgerAccount)}
        accounts={selectedLegalEntity?.financeAccounts}
        canManage
        disabled={readonly}
        onSelect={(id) => form.setValues({ ...form.values, ledgerAccountId: id })}
      />
    </Box>
  )
}
